import * as React from 'react';
import { ChangeEvent, FC, useState } from 'react';

import { TextInput } from '@rbilabs/components-library/build/components/text-input';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { DialogMemo } from 'components/dialog';
import { brandFont } from 'styles/brand-font';

import { TITLE_FONT_SIZE } from './constants';
import { ISaveFavoriteOrderProps } from './types';

/**
 *
 * Save Favorite Order
 *
 *
 */

const Text = styled.p``;
const Title = styled.h2`
  font: ${brandFont.headerOne};
  font-size: ${TITLE_FONT_SIZE};
  text-align: center;
  margin: 0;
`;
const StyledButton = styled(ActionButton)`
  text-overflow: unset;
  padding: 0.75rem;
`;

export const SaveFavoriteOrder: FC<ISaveFavoriteOrderProps> = ({ onSave, onDismiss }) => {
  const { formatMessage } = useIntl();
  const [favoriteName, setFavoriteName] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  const handleSave = () => {
    if (!favoriteName) {
      return setErrorMessage(formatMessage({ id: 'saveFavoriteOrderNameError' }));
    }
    onSave(favoriteName);
  };

  return (
    <DialogMemo
      data-testid="save-favorite-order"
      showCloseButton={true}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="Save Favorite Order"
      bodyComponent={
        <>
          <Title>{formatMessage({ id: 'nameYourFavorite' })}</Title>
          <Text>{formatMessage({ id: 'saveFavoriteOrderText' })}</Text>
          <TextInput
            aria-label={errorMessage ? errorMessage : formatMessage({ id: 'orderName' })}
            autoFocus
            data-testid="save-favorite-order-name"
            errorMessage={errorMessage}
            label={formatMessage({ id: 'orderName' })}
            onFocus={() => setErrorMessage('')}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setFavoriteName(event.currentTarget.value)
            }
            onBlur={() => {
              if (!favoriteName) {
                return setErrorMessage(formatMessage({ id: 'saveFavoriteOrderNameError' }));
              }
            }}
            required
            type="text"
            value={favoriteName}
          />
        </>
      }
      actions={
        <StyledButton
          allowFullScreen
          fullWidth
          onClick={handleSave}
          data-testid="save-favorite-order-button"
        >
          {formatMessage({ id: 'saveFavoriteOrderButton' })}
        </StyledButton>
      }
    />
  );
};
